import Icon from '../components/Icon.vue'

Icon.register({
  tshirt: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5C0.9 100.5-2.3 110.1 1.6 118L58.8 232.5C62.8 240.4 72.4 243.6 80.3 239.7L136.9 212C147.5 206.8 159.9 214.5 159.9 226.4V480C159.9 497.7 174.2 512 191.9 512H447.9C465.6 512 479.9 497.7 479.9 480V226.3C479.9 214.5 492.3 206.7 502.9 211.9L559.5 239.6C567.4 243.6 577 240.4 581 232.4L638.3 118C642.3 110.1 639.1 100.4 631.2 96.5z'
      }
    ]
  }
})
